export function getElementDepth(elt: Node): number {
	// eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
	if (!document.body || !document.body.contains(elt)) return 0;
	let depth = 0;
	while (elt.parentNode) {
		depth += 1;
		// eslint-disable-next-line no-param-reassign
		elt = elt.parentNode;
	}
	return depth;
}
